import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { recoverPassword } from '../../../services/auth';

interface IProps {
  payload: { code: string; password: string };
}

export const ThunkPasswordRecovery = createAsyncThunk<any, IProps>(
  `${storeResources.AUTH}/recoverPassword`,
  ({ payload }) => recoverPassword(payload).then(res => res.data),
);

export default {};
